import { createContext, useContext } from "react";
const QuizModeContext = createContext({ mode: "adult" });
const QuizModeProvider = QuizModeContext.Provider;
const useQuizMode = () => useContext(QuizModeContext);
export {
  QuizModeProvider,
  useQuizMode
};
//# sourceMappingURL=quiz-mode-context.js.map
